module.exports = __webpack_public_path__ + "static/media/arrow-alt-from-top.d7cc7556.svg";